var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('payment-methods-table',{staticClass:"mb-4",attrs:{"paymentMethods":_vm.paymentMethods,"loading":_vm.loading},on:{"reloadPaymentMethods":_vm.getPaymentMethods}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }